// extracted by mini-css-extract-plugin
export default {"draftUploadHeading":"DraftUpdate_draftUploadHeading__Y9lbK","mainHeadline":"DraftUpdate_mainHeadline__jm0jd"};